import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { RotateCcw, ShieldAlert } from 'lucide-react';

export default function AdminReset() {
    const { loading } = useAuth();
    const nav = useNavigate();
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    useEffect(() => {
        if (loading) return;
    }, [loading]);

    const reset = async () => {
        if (!window.confirm('Reset all demo data? This wipes families, plans, activity and reseeds Alex + Grace + family.')) return;
        setBusy(true);
        try {
            await api.resetDemo();
            setDone(true);
            toast.success('Demo data reset', { description: 'Seeded Alex + Grace + family. You may need to log in again.' });
            setTimeout(() => {
                localStorage.removeItem('nia_token');
                nav('/', { replace: true });
            }, 1500);
        } catch (e) {
            const detail = e.response?.data?.detail || 'Reset failed';
            toast.error(detail);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="nia-page">
            <div className="mobile-shell">
                <div className="nia-page-content" style={{ paddingTop: 40 }}>
                    <div className="nia-card" style={{ padding: 22, textAlign: 'center' }}>
                        <div style={{ width: 64, height: 64, margin: '0 auto 14px', borderRadius: 20, background: 'var(--nia-gold-tint)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <ShieldAlert size={28} color="#B58912" />
                        </div>
                        <h1 className="font-display" style={{ fontWeight: 900, fontSize: 22, margin: 0 }}>Admin · Reset demo</h1>
                        <p style={{ color: 'var(--nia-subtext)', fontSize: 13, marginTop: 8, lineHeight: 1.55 }}>
                            This wipes families, plans, bridges, emergencies and activity, then reseeds Alex Mwangi + Grace Wanjiku + Mary/Kevin/Aisha with sample data.
                        </p>
                        <p style={{ color: '#C0392B', fontSize: 12, marginTop: 10, fontWeight: 700 }}>
                            ⚠️ Cannot be undone. Use only on the private beta.
                        </p>
                        <button onClick={reset} disabled={busy || done} className="nia-btn-primary" style={{ marginTop: 16, display: 'inline-flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                            <RotateCcw size={16} /> {busy ? 'Resetting…' : done ? 'Done — redirecting…' : 'Reset demo data'}
                        </button>
                        <div style={{ marginTop: 14 }}>
                            <button onClick={() => nav(-1)} className="nia-btn-secondary" style={{ display: 'inline-block', width: 'auto', padding: '10px 18px' }}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
